module.exports = __webpack_public_path__ + "media/dorobek/assets/images/mnisw-contrast-86d23bbc2af3ec52f40932f8fc36ed6b.png";